interface ReplyKind {
  id: string;
  label: string;
  color: string;
}

interface Props {
  kinds: ReplyKind[];
  replyKind: string;
  replyText: string;
  replyBusy: boolean;
  replyError: string | null;
  onKindChange: (id: string) => void;
  onTextChange: (text: string) => void;
  onSend: () => void;
  onCancel: () => void;
}

export function IncidentReplyForm({
  kinds,
  replyKind,
  replyText,
  replyBusy,
  replyError,
  onKindChange,
  onTextChange,
  onSend,
  onCancel,
}: Props) {
  return (
    <div className="incident-reply-form" role="region" aria-label="Reply to citizen">
      <div className="incident-reply-kinds" role="radiogroup" aria-label="Message kind">
        {kinds.map((k) => (
          <button
            key={k.id}
            role="radio"
            aria-checked={replyKind === k.id}
            onClick={() => onKindChange(k.id)}
            className={`mono incident-reply-kind ${replyKind === k.id ? "active" : ""}`}
            style={replyKind === k.id ? { borderColor: k.color, color: k.color } : undefined}
            disabled={replyBusy}
          >
            {k.label}
          </button>
        ))}
      </div>
      <textarea
        className="incident-reply-text mono"
        value={replyText}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder="Message to the citizen — pushed to their LINE thread and recorded in audit log."
        rows={3}
        maxLength={1000}
        disabled={replyBusy}
        autoFocus
      />
      {replyError && (
        <span className="incident-reply-error caption" role="alert">{replyError}</span>
      )}
      <div className="incident-reply-actions">
        <button
          className="mono incident-reply-cancel"
          onClick={onCancel}
          disabled={replyBusy}
        >
          CANCEL
        </button>
        <button
          className="mono incident-reply-send"
          onClick={onSend}
          disabled={replyBusy || !replyText.trim()}
        >
          {replyBusy ? "SENDING…" : "SEND ↗"}
        </button>
      </div>
    </div>
  );
}
